(() => {
  let hub = null;
  let generation = 0;
  let products = {};
  let state = 'idle';
  let checkoutReady = false;
  const formatter = new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' });
  const nodes = () => [...document.querySelectorAll('[data-hub-price]')];

  const render = () => {
    nodes().forEach((node) => {
      node.dataset.basePrice ||= node.textContent;
      if (!hub) return;
      const variants = products[node.dataset.hubProduct];
      const amounts = Object.values(variants || {});
      const amount = node.dataset.hubVariant ? variants?.[node.dataset.hubVariant] : Math.min(...amounts);
      const quantity = Number(node.dataset.hubQuantity || 1);
      const from = node.parentElement.querySelector('[data-hub-from]');
      if (from) from.hidden = state !== 'ready' || new Set(amounts).size < 2;
      node.setAttribute('aria-busy', String(state === 'loading'));
      if (state === 'loading') node.textContent = 'Loading branch price…';
      else if (state === 'error') node.textContent = 'Branch price unavailable';
      else if (!Number.isFinite(amount)) node.textContent = 'No price in this catalog';
      else node.textContent = `${formatter.format(amount * quantity / 100)} ZAR`;
    });
    const subtotal = document.querySelector('[data-branch-subtotal]');
    if (subtotal && hub) {
      const lines = [...document.querySelectorAll('[data-branch-line]')];
      const amounts = lines.map(line => products[line.dataset.hubProduct]?.[line.dataset.hubVariant]);
      subtotal.textContent = state === 'loading' ? 'Loading branch prices…' :
        state !== 'ready' || amounts.some(amount => !Number.isSafeInteger(amount)) ? 'Branch prices unavailable' :
          `${formatter.format(lines.reduce((sum, line, index) => sum + amounts[index] * Number(line.dataset.quantity), 0) / 100)} ZAR`;
    }
  };

  window.MyWasteBranchCart = Object.freeze({
    expectedPrices(cart, selectedHub) {
      if (hub !== selectedHub || state !== 'ready') throw new Error('Wait for branch prices to load, or refresh the cart.');
      if (!checkoutReady) throw new Error('Branch checkout is not connected in this preview yet. No request has been submitted.');
      const rows = [...document.querySelectorAll('[data-branch-line]')];
      if (rows.length !== cart.items.length || rows.some((row, index) =>
        row.dataset.lineKey !== cart.items[index].key || Number(row.dataset.quantity) !== cart.items[index].quantity ||
        Number(row.querySelector('input[name="updates[]"]').value) !== cart.items[index].quantity)) {
        throw new Error('Update your cart quantities before continuing.');
      }
      return cart.items.map(item => {
        const price = products[String(item.product_id)]?.[String(item.variant_id)];
        if (!Number.isSafeInteger(price) || price < 0) throw new Error('An item has no price in this branch catalog.');
        return price;
      });
    },
  });

  const refresh = async (selectedHub) => {
    const dialog = document.querySelector('[data-location-dialog]');
    if (dialog?.dataset.currentCountryCode !== 'ZA' || !['Johannesburg', 'Cape Town'].includes(selectedHub)) return;
    hub = selectedHub;
    const current = ++generation;
    const ids = [...new Set(nodes().map((node) => node.dataset.hubProduct))];
    if (!ids.length) return;
    products = {};
    checkoutReady = false;
    state = 'loading';
    render();
    try {
      const nextProducts = {};
      let nextCheckoutReady = true;
      for (let index = 0; index < ids.length; index += 24) {
        const root = window.Shopify?.routes?.root || '/';
        const query = new URLSearchParams({ action: 'catalog-prices', hub, products: ids.slice(index, index + 24).join(',') });
        const response = await fetch(`${root}apps/delivery-request?${query}`, { signal: AbortSignal.timeout(15_000), cache: 'no-store' });
        if (current !== generation) return;
        if (!response.ok) throw new Error('Catalog unavailable');
        const data = await response.json();
        if (current !== generation) return;
        if (data.hub !== selectedHub || data.currency !== 'ZAR' || !data.products) throw new Error('Invalid catalog response');
        nextCheckoutReady = nextCheckoutReady && data.checkoutVersion === 1;
        Object.assign(nextProducts, data.products);
      }
      products = nextProducts;
      checkoutReady = nextCheckoutReady;
      state = 'ready';
    } catch (_error) {
      if (current !== generation) return;
      state = 'error';
    }
    render();
  };

  document.addEventListener('hub:change', (event) => refresh(event.detail.hub));
  document.addEventListener('hub:variant-change', render);
  document.addEventListener('shopify:section:load', () => { if (hub) refresh(hub); });
  window.addEventListener('pageshow', (event) => { if (event.persisted && hub) refresh(hub); });
})();
